/* eslint-disable react/require-default-props */
import { createFilterOptions } from '@material-ui/lab';
import React from 'react';
import color from '../../constants/color';
import materialUI from '../../material-UI';
import { AutoCompleteCustom, Text } from './styls';

interface Props {
  onChange: any;
  data: Array<any>;
  label: string;
  limitResult?: number;
  value: string;
}

const useStyles = materialUI.makeStyles({
  root: {
    '& fieldset': {
      borderRadius: 40,
      color: 'red',
    },
    '& .MuiAutocomplete-inputRoot': {
      color: color.grey9,
    },
  },
});

const AutoComplete: React.FC<Props> = ({
  onChange, data, label, limitResult, value,
}) => {
  const filterOptions = createFilterOptions({
    limit: limitResult,
  });
  return (
    <AutoCompleteCustom
      filterOptions={filterOptions}
      classes={{ root: useStyles().root }}
      options={data}
      value={value}
      clearOnBlur
      getOptionLabel={(option: any) => option.label}
      onChange={(event: any, newValue) => {
        onChange(newValue);
      }}
      renderInput={(params) => <Text {...params} label={label} variant="outlined" />}
    />
  );
};
export default AutoComplete;
